import { Button, Space, Tabs, Row, Col } from 'antd';
import { Suspense, lazy } from 'react';
import { Routes, Route } from 'react-router-dom';
import { AppstoreOutlined, UserOutlined, SettingOutlined, UnorderedListOutlined, BarChartOutlined, ClearOutlined, HeartOutlined, IdcardOutlined, MehOutlined, MonitorOutlined, StarOutlined, ToolOutlined } from '@ant-design/icons';
import Sidebar, { getItem } from '../../components/navigation/Sidebar';
import './App.css';

import Bans from './components/Bans/Bans';
import Forbes from './components/Users/Forbes';
import Users from './components/Users/Users';
import ViewUser from './components/Users/ViewUser';
import Vehicles from './components/Users/Vehicles';
import ViewVehicle from './components/Users/ViewVehicle';
import Management from './components/Management/Management';
import ErrorFallback from '../../static-pages/500_NoBtn';

function Welcome() {
  return (
    <div>
      <h1>Welcome to the admin panel</h1>
      <p>Use the navigation on the left to get started</p>

      <h3>Please remember to never share this page on your stream, or to anyone who is not authorized to use it.</h3>
    </div>
  );
}

function App() {
  const items = [
    getItem('Characters', 'sub1', <UserOutlined />, [
      getItem('All characters', '1', <UnorderedListOutlined />, null, 'link', 'characters'),
      getItem('All vehicles', '2', <UnorderedListOutlined />, null, 'link', 'vehicles'),
      getItem('Bans', '3', <ClearOutlined />, null, 'link', 'bans'),
      getItem('Forbes 100', '4', <BarChartOutlined />, null, 'link', 'forbes'),
      getItem('Misc', '5', <HeartOutlined />),
    ]),
    getItem('Management', 'sub2', <AppstoreOutlined />, [
      getItem('Staff', '6', <IdcardOutlined />, null, 'link', 'management/staff'),
      getItem('Config', '7', <SettingOutlined />),
    ]),
    getItem('Logs', 'sub4', <SettingOutlined />, [
      getItem('Player actions', '8', <MonitorOutlined />),
      getItem('Cheater flags', '9', <MehOutlined />),
      getItem('Staff actions', '10', <StarOutlined />),
      getItem('Management actions', '11', <ToolOutlined />),
    ]),
  ];

  return (
    <Row wrap={false} gutter={20} width="100%">
      <Col flex="none">
        <Sidebar items={items} />
      </Col>
      <Col flex="auto">
        <Suspense fallback={<ErrorFallback />}>
          <Routes>
            <Route path="/" element={<Welcome />} />
            <Route path="/bans" element={<Bans />} />
            <Route path="/forbes" element={<Forbes />} />
            <Route path="/characters" element={<Users />} />
            <Route path="/characters/:id" element={<ViewUser />} />
            <Route path="/vehicles" element={<Vehicles />} />
            <Route path="/vehicles/:id" element={<ViewVehicle />} />
            <Route path="/management/staff" element={<Management />} />
            <Route path="*" element={<ErrorFallback />} />
          </Routes>
        </Suspense>
      </Col>
    </Row>
  );
}

export default App;
